import ajax from '../ajax'

// 模型图片移动
// export function changePSImgApi(data) {
//     return ajax({
//         method:'post',
//         url: 'v2/ps/changeProcess',
//         data
//     })
// }

  //ERP table数据
export function   ERPListApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/index',
        params
    })
}

  //ERP 小组下拉数据
export function   DropdownApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/search',
        params
    })
}


//确认是否有token登录
export function   statusApi(params) {
    return ajax({
        method:'get',
        url: 'api/user/status',
        params
    })
}
// 权限管理  /api/user/status
export function StatusApi(params) {
    return ajax({
        method:'get',
        url: '/api/user/status',
        params
    })
}

//切换项目进度
export function ScheduleApi(data) {
    return ajax({
        method:'post',
        url: 'api/project/status',
        data
    })
}

//进度备注和制作备注
export function RemarkApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/remark',
        params
    })
}

//点击新增然后新增备注数据
export function AddApi(data) {
    return ajax({
        method:'post',
        url: 'api/project/add_remark',
        data
    })
}

//点击新增然后新增备注数据
export function EditApi(data) {
    return ajax({
        method:'post',
        url: 'api/project/edit',
        data
    })
}

//点击获取编辑页面接口
export function InfoApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/info',
        params
    })
}

//api/project/del
export function DelApi(data) {
    return ajax({
        method:'post',
        url: 'api/project/del',
        data
    })
}


//api/project/remarklist

export function RemarklistApi(params) {
    return ajax({
        method:'get',
        url: 'api/project/remarklist',
        params
    })
}


///api/image/del
export function DeleApi(data) {
    return ajax({
        method:'post',
        url: 'api/image/del',
        data
    })
}



export function InfoTwoApi(params) {
    return ajax({
        method:'get',
        url: '/api/image/info',
        params
    })
}

///api/project/delremark

export function DelremarkApi(data) {
    return ajax({
        method:'post',
        url: 'api/project/delremark',
        data
    })
}


//api/income/info?id=2
export function  IncomeApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/info',
        params
    })
}


export function  SearchApi(params) {
    return ajax({
        method:'get',
        url: 'api/customer/search',
        params
    })
}



// api/contract.js

export function UploadContractApi(data) { // 注意：是 data，不是 params
    return ajax({
      method: 'post',           // 必须是 post
      url: 'api/pdf/sign', // 换成你真实的上传接口
      data,                      // 传 FormData
    })
 }


 export function UploadctApi(data) { // 注意：是 data，不是 params
    return ajax({
      method: 'post',           // 必须是 post
      url: 'api/pdf/finish', // 换成你真实的上传接口
      data,                      // 传 FormData
    })
 }
 


 //删除pdf 的合同
 export function CloneApi(data) { // 注意：是 data，不是 params
    return ajax({
      method: 'post',           // 必须是 post
      url: '/api/pdf/del', // 换成你真实的上传接口
      data,                      // 传 FormData
    })
 }



// WEBPACK FOOTER //
// ./src/api/home/home.js